export default __webpack_public_path__ + "assets/e130518a67ebe145f1cf991d20f9c70f.jpeg";